
import Vue from "vue";
import msDataProvider from "../../services/msDataProvider";
import uiService from "../../services/uiService";
import {mdiArrowRight} from '@mdi/js';
import {addAction} from "@/services/firebase/writeData";

export default Vue.extend({
  data() {
    return {
      mdiArrowRight,
      binding: {},
      loading: false
    };
  },
  methods: {
    goToHomePage() {
      sessionStorage.setItem("confirmDeviceSuccess", "true");
      this.$router.push('/');
    },
    async exit() {
      if (
          await uiService.executeCommand(
              "confirmShow",
              {
                message: this.$t("LAYOUT.DO_YOU_REALLY_WANT_TO_EXIT_THIS_APP"),
                title: this.$t("LAYOUT.CONFIRM_EXIT"),
                cancel: this.$t("LAYOUT.CANCEL"),
                ok: this.$t("LAYOUT.EXIT"),
              },
              true
          )
      ) {
        uiService.executeCommand("try", {
          async func() {
            await msDataProvider.executeCommand("appExit", {});
            this.$router.push("/prepare").catch((e) => e);
          },
          self: this,
        });
      }
      await addAction('click_to_exit_app')
    },
    async logout() {
      this.loading = true;
      await uiService.executeCommand(
          "try",
          {
            async func() {
              await msDataProvider.executeCommand(
                  "authenLogout"
              );
              this.$router.push("/prepare").catch((e) => e);
            },
            self: this
          },
          true
      );
      sessionStorage.removeItem('userId');
      this.loading = false;
    },
    async tryAgain() {
      this.loading = true;
      await uiService.executeCommand(
          "try",
          {
            async func() {
              await msDataProvider.executeCommand(
                  "enrollmentCancelEnrollmentRequest"
              );
              this.$router.push("/prepare").catch((e) => e);
            },
            self: this
          },
          true
      );
      this.loading = false;
    }
  },
  created() {
    msDataProvider.bindData(
        "enrollmentEnrollmentStatus",
        this.binding,
        this,
        (value) => {
          if (value && value.approved) {
            this.$router.push('/main');
          }
        },
        this
    );
  },
  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    next();
  }
});
